<template>
<b-tab lazy title-item-class="mb-1">
    <template slot="title">Procedures</template>
    <procedures-base button-top small :callback="createProcedure" />
</b-tab>
</template>
<script>
import TabExtension from "./TabExtension"
import ProceduresBase from "@/core/components/procedures/ProceduresBase"
import { mapActions } from "vuex"
export default TabExtension.extend({
    name: "procedures",
    components: {
        'procedures-base': ProceduresBase
    },
    methods: {
        ...mapActions('procedures', ['createProcedure']),
    }
})
</script>